/* auto-generated: @mui/icons-material */
import Base from '@mui/icons-material/Dangerous';
import {withMuiAdapter} from '@common/icons/with-mui-adapter';

export const DangerousIcon = withMuiAdapter(Base, 'Dangerous');
